import { z } from 'zod';

export const validateEmail = (email: string): boolean =>
  z.string().email().safeParse(email).success;

export interface ParseInviteEmailsResult {
  emails: string[];
  invalid: string[];
}

/**
 * Parse a bulk invite email list.
 * Splits on newlines, commas, and semicolons; trims; de-dupes case-insensitively.
 */
export const parseInviteEmails = (input: string): ParseInviteEmailsResult => {
  const parts = input
    .split(/[\n,;]+/u)
    .map((part) => part.trim())
    .filter(Boolean);

  const seen = new Set<string>();
  const emails: string[] = [];
  const invalid: string[] = [];

  for (const part of parts) {
    const key = part.toLowerCase();
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);

    if (validateEmail(part)) {
      emails.push(part);
    } else {
      invalid.push(part);
    }
  }

  return { emails, invalid };
};
